<template>
  <div class="hero">
    <slot name="sidebar" :isFirstSlide="isFirstSlide"></slot>

    <div class="swiper-container">
      <div class="swiper-wrapper">
        <a
          :href="slide.link"
          v-for="(slide, idx) in slideData"
          :key="`slide-${idx}`"
          class="swiper-slide"
        >
          <figure>
            <picture>
              <source :srcset="slide.image.small" media="(max-width: 480px)" />
              <source :srcset="slide.image.medium" media="(max-width: 768px)" />
              <source
                :srcset="slide.image.medium"
                media="(max-height: 900px)"
              />
              <img :src="slide.image.large" class="media__image" alt="" />
            </picture>
            <figcaption
              class="hero__caption"
              :class="`hero__caption--${slide.caption.color}`"
            >
              <p>
                {{ slide.caption.line1 }}
                <span v-if="slide.caption.line2">{{
                  slide.caption.line2
                }}</span>
              </p>
            </figcaption>
          </figure>
        </a>
      </div>
      <button type="button" class="swiper-button-next d-none d-lg-block">
        <ahc-icon
          icon-name="arrow-right-circle"
          icon-name-hover="arrow-right-circle-hover"
          :focus-parent="true"
          width="96"
          height="96"
        >
        </ahc-icon>
        <span class="sr-only">Next Slide</span>
      </button>
    </div>
  </div>
</template>

<script lang="js">
import ahcIcon from "../icon/icon.vue";
import Swiper, {Navigation} from 'swiper';

Swiper.use([Navigation]);

export default {
  name: 'ahc-hero',
  components: {
    ahcIcon,
  },
  props: {
    slideData: {
      type: Array,
      required: true,
    }
  },
  computed: {
    isFirstSlide() {
      return this.currentSlide !== 0 && this.$breakpoint.lgAndUp;
    },
  },
  data() {
    return {
      heroSwiper: null,
      totalSlides: 1,
      currentSlide: 0,
      ready: false
    }
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    /**
     * Initialize swiper.js
     */
    initSwiper() {
      const vm = this;
      const swiperOptions = {
        init: false,
        loop: true,
        loopAdditionalSlides: 1,
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        direction: 'horizontal',
        navigation: {
          nextEl: '.hero .swiper-button-next',
        },
        pagination: false,
        a11y: true,
        keyboard: {
          enabled: true,
        },
        on: {
          init: function () {
            vm.ready = true;
            vm.setTabIndexes();
          },
          slideChange: function () {
            vm.currentSlide = vm.heroSwiper.realIndex;
            vm.setTabIndexes();
          }
        }
      };

      const swiperContainer = this.$el.querySelector('.swiper-container');
      this.heroSwiper = new Swiper(swiperContainer, swiperOptions);
      this.heroSwiper.init();
      vm.ready = true;
    },
    /**
     * When slides change, we want to disable tabbing on slides that
     * aren't the active one.
     */
    setTabIndexes() {
      this.$nextTick(() => {
        const slides = this.$el.querySelectorAll('.swiper-slide');
        slides.forEach((slide) => {
          // both active slide and next slide are visible, so they need to be available to keyboards and screen readers
          if(slide.classList.contains('swiper-slide-active') || slide.classList.contains('swiper-slide-next')) {
            slide.setAttribute('tabindex', '0');
            slide.setAttribute('aria-hidden', 'false');
          } else {
            slide.setAttribute('tabindex', '-1'); // keep non-visible slides from tab order
            slide.setAttribute('aria-hidden', 'true'); // hide non-visible slides from screen readers
          }
        })
      })
    }
  },
}
</script>

<style lang="scss">
@import "hero";
</style>
